import {
  createFileRoute,
  notFound,
  stripSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';
import ListAnalytes from '../../../pages/listAnalytes/ListAnalytes';
import { VIEW_ANALYTE_PAGE } from '../../../utils/permissions';

const searchDefaults = {
  taxonomicSuperclasses: [],
  classificationClass: '',
  classificationSubclass: '',
  classificationParentLevel1: '',
  useCase: [],
  product: [],
  method: [],
  heavyLabel: 'Light',
  chemicalFormula: '',
  smiles: '',
  inChI: '',
  inChIKey: '',
  pubChemCID: '',
  mode: 'Method',
  search: '',
  tags: [],
  restrictedTags: [],
  page: 1,
  rowsPerPage: 100,
} as const;

// Using .catch() instead of .default() to gracefully handle both missing
// and invalid values (e.g., ?page=abc falls back to 1 instead of throwing)
const searchSchema = z.object({
  taxonomicSuperclasses: z
    .array(z.string())
    .catch([...searchDefaults.taxonomicSuperclasses]),
  classificationClass: z.string().catch(searchDefaults.classificationClass),
  classificationSubclass: z
    .string()
    .catch(searchDefaults.classificationSubclass),
  classificationParentLevel1: z
    .string()
    .catch(searchDefaults.classificationParentLevel1),
  useCase: z.array(z.string()).catch([...searchDefaults.useCase]),
  product: z.array(z.string()).catch([...searchDefaults.product]),
  method: z.array(z.string()).catch([...searchDefaults.method]),
  heavyLabel: z.string().catch(searchDefaults.heavyLabel),
  chemicalFormula: z.string().catch(searchDefaults.chemicalFormula),
  smiles: z.string().catch(searchDefaults.smiles),
  inChI: z.string().catch(searchDefaults.inChI),
  inChIKey: z.string().catch(searchDefaults.inChIKey),
  pubChemCID: z.string().catch(searchDefaults.pubChemCID),
  mode: z.enum(['Method', 'Compound']).catch(searchDefaults.mode),
  search: z.string().catch(searchDefaults.search),
  tags: z.array(z.string()).catch([...searchDefaults.tags]),
  restrictedTags: z.array(z.string()).catch([...searchDefaults.restrictedTags]),
  page: z.number().catch(searchDefaults.page),
  rowsPerPage: z.number().catch(searchDefaults.rowsPerPage),
});

export type ListAnalytesSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/_authenticated/_navbar/list-analytes')({
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(searchDefaults)],
  },
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_ANALYTE_PAGE)) {
      throw notFound();
    }
  },
  component: ListAnalytes,
});
